// const homeHero = () => {
//     if ($('.home-hero').length) {

//         let homeHeroAnimate = class {

//             constructor() {
//                 (this.outer = document.querySelector(".home-hero")),
//                     (this.mask = document.querySelector(".home-hero__overlay")),
//                     (this.intro = document.querySelector(".home-hero__intro")),
//                     (this.introContent = document.querySelector(".home-hero__intro")),
//                     (this.introContentWrap = document.querySelector(".home-hero__intro--content-wrap")),
//                     (this.heroWrap = document.querySelector(".home-hero__wrap")),
//                     (this.spinner = document.querySelector(".spinning-scroll")),
//                     (this.left = document.querySelectorAll(".home-hero__image-left")),
//                     (this.right = document.querySelectorAll(".home-hero__image-right")),
//                     (this.title = document.querySelector(".hero-hero__title")),
//                     (this.headline = document.querySelector(".home-hero__title")),
//                     (this.height = (this.introContent.offsetHeight)),
//                     (this.hero = document.querySelector(".home-hero__inner")),
//                     (this.copy = document.querySelector(".home-hero__copy")),
//                     (this.video = document.querySelector('.home-hero__video')),
//                     (this.leftImages = document.querySelectorAll(".home-hero__image-left img")),
//                     (this.rightImages = document.querySelectorAll(".home-hero__image-right img")),
//                     (this.gsap = gsap.registerPlugin(ScrollTrigger)),
//                     this.init();
//             }

//             init() {
//                 this.addIntroAnimation(), this.scrollTimeline();
//             }

//             addIntroAnimation() {
//                 gsap.registerPlugin(ScrollTrigger);
//                 gsap.timeline({id: "intro", defaults: {ease: "expo"}})
//                     .set([this.outer, this.hero], {autoAlpha: 1})
//                     .set(this.mask, {scale: 0, autoAlpha: 0, y: -400})
//                     .set([...this.leftImages, ...this.rightImages], {y: -280, autoAlpha: 0, scale: 0})
//                     .to(this.mask, {scale: 1, duration: 1, ease: "expo", autoAlpha: 1})
//                     .to([...this.leftImages, ...this.rightImages], {
//                         scale: 1,
//                         autoAlpha: 1,
//                         duration: 0.5,
//                         ease: "expo",
//                         stagger: {each: 0.075, from: "center"}
//                     }, '<0.4')
//                     .to(this.mask, {y: 0, autoAlpha: 1, duration: 1.25, ease: "expo.out"})
//                     .to([...this.leftImages, ...this.rightImages], {
//                         y: 0,
//                         autoAlpha: 1,
//                         duration: 1,
//                         ease: "expo.out",
//                         stagger: {each: 0.03, from: "end"}
//                     }, '<0.3')
//                     .from(this.headline, {autoAlpha: 0, duration: 2, ease: "expo", y: -100}, '<0.6')
//                     .from(this.copy, {autoAlpha: 0, duration: 2, ease: "expo", y: -40}, '<0.6')
//                     .to(this.spinner, {autoAlpha: 1, duration: 0.9, ease: "expo.out"});
//             }

//             // timelineIntro() {
//             //     tl.fromTo(this.intro,
//             //         {
//             //             opacity: 0,
//             //         },
//             //         {
//             //             scrollTrigger: {
//             //                 trigger: this.heroWrap,
//             //                 start: "top",
//             //                 end: "bottom",
//             //                 scrub: 1,
//             //                 // pin: true,
//             //                 // anticipatePin: 2,
//             //                 // markers: true,
//             //             },
//             //             opacity: 1,
//             //             ease: "linear",
//             //             duration: 1
//             //         }, '<0.25')
//             //     tl.fromTo(this.intro,
//             //         {
//             //             y: 1,
//             //         },
//             //         {
//             //             scrollTrigger: {
//             //                 trigger: this.heroWrap,
//             //                 start: "top",
//             //                 end: "bottom",
//             //                 scrub: 1,
//             //                 snap: 1,
//             //                 pin: true,
//             //                 anticipatePin: 2,
//             //                 markers: true,
//             //             },
//             //             y: 1,
//             //             ease: "linear",
//             //             duration: 1
//             //         }, '<0.25')
//             // }

//             scrollTimeline() {
//                 if (window.innerWidth < 992) {
//                     return;
//                 }

//                 let percentage = (this.height / 100) * 10;

//                 gsap.registerPlugin(ScrollTrigger);
//                 gsap.timeline({onStart: this.playVideo.bind(this)})
//                     .fromTo(this.mask, {y:0}, {
//                         scrollTrigger: {
//                             trigger: this.heroWrap,
//                             start: "top",
//                             end: "+=" + (this.height + percentage),
//                             scrub: 1,
//                             pin: true,
//                             anticipatePin: 1,
//                             // markers: true,
//                         },
//                         y: 0, 
//                         ease: "linear",
//                         duration: 1
//                     })
//                     .fromTo(this.mask, {clipPath: "inset(10% 30% 10% 30%)"}, {
//                         scrollTrigger: {
//                             trigger: this.heroWrap,
//                             start: "top",
//                             end: "bottom",
//                             scrub: 1,
//                             // markers: true,
//                         },
//                         clipPath: "inset(0% 0% 0% 0%)",
//                         ease: "linear",
//                         duration: 1
//                     })
//                     .fromTo(this.spinner,
//                         {
//                             opacity: 1
//                         },
//                         {
//                             scrollTrigger: {
//                                 trigger: this.heroWrap,
//                                 start: "top",
//                                 end: "+=400px",
//                                 scrub: 1,
//                                 // markers: true,
//                             },
//                             opacity: 0,
//                             ease: "linear",
//                             duration: 1
//                         })
//                     .fromTo(this.left,
//                         {
//                             xPercent: 0
//                         },
//                         {
//                             scrollTrigger: {
//                                 trigger: this.heroWrap,
//                                 start: "top",
//                                 end: "bottom",
//                                 scrub: 1,
//                                 // markers: true,
//                             },
//                             xPercent: -200,
//                             ease: "linear",
//                             duration: 1
//                         }, "<")
//                     .fromTo(this.right,
//                         {
//                             xPercent: 0
//                         },
//                         {
//                             scrollTrigger: {
//                                 trigger: this.heroWrap,
//                                 start: "top",
//                                 end: "bottom",
//                                 scrub: 1,
//                                 // markers: true,
//                             },
//                             xPercent: 200,
//                             ease: "linear",
//                             duration: 1
//                         }, "<")
//                 .fromTo(this.intro,
//                     {
//                         opacity: 0,
//                     },
//                     {
//                         scrollTrigger: {
//                             trigger: this.introContent,
//                             start: "top",
//                             end: "top +=400px",
//                             scrub: 1,
//                             // markers: true,
//                         },
//                         opacity: 1,
//                         ease: "linear",
//                         duration: 1
//                     }, '<0.25')
//                     .fromTo(this.introContentWrap,
//                         {
//                             y: 0,
//                         },
//                         {
//                             scrollTrigger: {
//                                 trigger: this.introContent,
//                                 start: "+=500px",
//                                 end: "+=" + this.height,
//                                 scrub: 1,
//                                 // markers: true,
//                             },
//                             y: '-' + this.height,
//                             ease: "linear",
//                             duration: 1
//                         }, '<0.25')
//             }

//             playVideo() {
//                 this.video.play();
//             }
//         };

//         new homeHeroAnimate();
//     }
// }

const homeHero = () => {

    if ($('.home-hero').length && $(window).width() > 992) {

        console.log('Ready to run hero');

        var html = document.documentElement;
        var body = document.body;

        var scroller = {
            target: document.querySelector("#scroll-container"),
            ease: 0.05, // <= scroll speed
            endY: 0,
            y: 0,
            z: 0,
            resizeRequest: 1,
            scrollRequest: 0,
        };

        var requestId = null;
        var videoTop = 0;

        document.addEventListener("scroll", onheroScroll);

        function onheroScroll() {
            scroller.scrollRequest++;
            if (!requestId) {
                requestId = requestAnimationFrame(heroScroll);
            }
        }

        function heroScroll() {

            var scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;
          
            scroller.y += (scrollY - scroller.y) * scroller.ease;
          
            if (Math.abs(scrollY - scroller.y) < 0.05) {
                scroller.y = scrollY;
                scroller.scrollRequest = 0;
            }
            
            const headerHeight = $('.c-header').outerHeight();
            const heroOffset = $('.home-hero__cols').offset().top - headerHeight;
            const videoOffset = $('.home-hero__video').offset().top;

            if(scroller.y < heroOffset) {
                var percentage = (scroller.y / heroOffset) * 100;
                $('.home-hero__video').css('top', '0');
                $('.home-hero__video').css('position', 'fixed');
            } else {
                var percentage = 101;
                $('.home-hero__video').css('top', headerHeight+'px');
                $('.home-hero__video').css('position', 'fixed');
            }

            if(percentage < 35) {
                $('.home-hero__video__overlay').css('opacity', '0.'+parseInt(percentage));
            }

            if(percentage > 5) {
                $('.scroll-down').addClass('fade-out');
            } else {
                $('.scroll-down').removeClass('fade-out');
            }

            TweenMax.set($('.home-hero__image-right'), {'transform': 'translateZ(0) translateX('+percentage+'%)'});
            TweenMax.set($('.home-hero__image-left'), {'transform': 'translateZ(0) translateX(-'+percentage+'%)'});

            TweenMax.set($('.home-hero__video__bottom-overlay'), {'transform': 'translateZ(0) translateY('+percentage+'%)'});
           
       
            requestId = scroller.scrollRequest > 0 ? requestAnimationFrame(heroScroll) : null;
        }
    }
}